import * as React from 'react'
import styled, { ThemeProps } from 'style/styled-components'
import Theme from 'style/theme'

interface RuleProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation: RuleOrientation
  ruleStyle: RuleStyle
  thickness: number
}

export enum RuleOrientation {
  vertical,
  horizontal
}

export enum RuleStyle {
  solid = 'solid',
  dotted = 'dotted',
  dashed = 'dashed'
}

const borderWidth = (orientation: RuleOrientation, thickness: number): string =>
  orientation === RuleOrientation.horizontal
    ? `${thickness}px 0 0 0`
    : `0 ${thickness}px 0 0`

const Rule = (props: RuleProps): JSX.Element => {
  const StyledRule = styled.div`
      border-style: ${props.ruleStyle};
      border-width: ${borderWidth(props.orientation, props.thickness)};
      border-color: ${(themeProps: ThemeProps<Theme>): string => themeProps.theme.separator.color};
    `

  return <StyledRule {...props} />
}

export default Rule



// WEBPACK FOOTER //
// ./src/components/_atoms/rule.tsx